<script>
/**
 * basic functionality for item display
 */
export default {
    name: 'itemMixin',
    methods: {
        scaleText(num, scale) {
        if (this.item.labels.length > 0) {
            if (num === 1 && this.item.labels.find(l => l.subtype === 'SCALE_LABEL_MIN'))
            return this.$t(this.item.labels.find(l => l.subtype === 'SCALE_LABEL_MIN').text);
            if (num === scale && this.item.labels.find(l => l.subtype === 'SCALE_LABEL_MAX'))
            return this.$t(this.item.labels.find(l => l.subtype === 'SCALE_LABEL_MAX').text);
            if (this.item.labels.find(l => l.subtype === `SCALE_LABEL_${num}`))
            return this.$t(this.item.labels.find(l => l.subtype === `SCALE_LABEL_${num}`).text);
        }
        return num;
        }
    }
}
</script>